import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=dc67dbf2&"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsComponent.vue?vue&type=style&index=0&id=dc67dbf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports